exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan[data-v-024917cc] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 24px;\n    word-break: break-all;\n    white-space: pre-line;\n}\n", ""]);

// exports
